import { LogOut, Package, Calendar, MessageSquare, Bell, ChevronLeft, ChevronRight, Home, Search, Moon, Tag } from 'lucide-react'
import styles from '@styles/AdminPanel.module.css'
import PropTypes from 'prop-types'

const Sidebar = ({ isCollapsed, setIsCollapsed, activeSection, setActiveSection, searchTerm, handleSearch, toggleDarkMode, logout }) => {
  return (
    <div className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ''}`}>
      <div className={styles.sidebarHeader}>
        <div className={styles.logo}>
          <span className={styles.logoIcon}>A</span>
          {!isCollapsed && <span className={styles.logoText}>Admin</span>}
        </div>
        <button
          className={styles.collapseButton}
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>
      <div className={styles.searchContainer}>
        <Search size={20} />
        {!isCollapsed && (
          <input
            type='text'
            placeholder='Buscar...'
            className={styles.searchInput}
            value={searchTerm}
            onChange={handleSearch}
          />
        )}
      </div>

      <nav className={styles.nav}>
        {[
          { id: 'dashboard', icon: Home, label: 'Dashboard' },
          { id: 'products', icon: Package, label: 'Productos' },
          { id: 'appointments', icon: Calendar, label: 'Citas' },
          { id: 'messages', icon: MessageSquare, label: 'Mensajes' },
          { id: 'reminders', icon: Bell, label: 'Recordatorios' },
          { id: 'offers', icon: Tag, label: 'Ofertas' },
        ].map(({ id, icon: Icon, label }) => (
          <button
            key={id}
            onClick={() => setActiveSection(id)}
            className={`${styles.navButton} ${
              activeSection === id ? styles.active : ''
            }`}
          >
            <Icon size={20} />
            {!isCollapsed && <span>{label}</span>}
          </button>
        ))}
      </nav>

      <div className={styles.sidebarFooter}>
        <button onClick={toggleDarkMode} className={styles.navButton}>
          <Moon size={20} />
          {!isCollapsed && <span>Modo Oscuro</span>}
        </button>

        <button onClick={logout} className={styles.navButton}>
          <LogOut size={20} />
          {!isCollapsed && <span>Cerrar Sesión</span>}
        </button>
      </div>
    </div>
  )
}

Sidebar.propTypes = {
    isCollapsed: PropTypes.bool.isRequired,
    setIsCollapsed: PropTypes.func.isRequired,
    activeSection: PropTypes.string.isRequired,
    setActiveSection: PropTypes.func.isRequired,
    searchTerm: PropTypes.string.isRequired,
    handleSearch: PropTypes.func.isRequired,
    toggleDarkMode: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
  }

export default Sidebar
  